<template>
  <div name="snackbars">
    <v-snackbar :left="left" :right="right" :top="top" :bottom="bottom" :centered="centered"  v-model="show" :color="color" :timeout="timeout"  >
      <div class="d-flex">
        <v-icon width="30px" style="width: 30px">{{icon}}</v-icon> <span v-html="text"></span>
      </div>
        <template v-slot:action="{ attrs }">
          <v-btn small light icon v-bind="attrs" @click="show = false">
           <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "snackbar/SHOW_MESSAGE") {
        this.text = state.snackbar.text;
        this.color = state.snackbar.color;
        this.timeout = state.snackbar.timeout;
        this.icon = state.snackbar.icon;    
        this.left = state.snackbar.left;    
        this.right = state.snackbar.right;    
        this.top = state.snackbar.top;    
        this.bottom = state.snackbar.bottom;    
        this.centered = state.snackbar.centered;    
        this.show = true;
      }
    });
  },
  data() {
    return {
      show: false,
      color: "",
      text: "",
      timeout: -1,
      left: false,
      right: false,
      top: false,
      bottom: false,
      centered: false,
      icon: '',
    };
  },
};
</script>